import * as React from "react";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import PriorityName from "components/events/events/PriorityName";
const EventTypeFilter = ({ onSelect, selectedValues }) => /* @__PURE__ */ React.createElement(ListGroup, { className: "no-bm" }, Object.keys(EventDefinitionPriorityEnum.properties).map((priority) => {
  const disabledOption = selectedValues.includes(priority);
  return /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => !disabledOption && onSelect(priority), disabled: disabledOption, key: priority }, /* @__PURE__ */ React.createElement(PriorityName, { priority: Number(priority) }));
}));
export default EventTypeFilter;
